// Whether a list attribute of the vehicle selection keeps the listed values ("any of") or
// rejects them ("everything except").
export const VehicleSelectionOperator = {
  INCLUDED: 'INCLUDED',
  EXCLUDED: 'EXCLUDED',
} as const;

export type VehicleSelectionOperator =
  (typeof VehicleSelectionOperator)[keyof typeof VehicleSelectionOperator];
